import Vue from 'vue';
import Router from 'vue-router';
import Overview from './components/Overview.vue';
import Settings from './components/Settings.vue';


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Overview',
      component: Overview,
    },
    {
      path: '/einstellungen',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ],
});
